import React from 'react'
import { useIntl } from "react-intl";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import { setBlockedTimeReason } from "../../Redux";

interface Props {
  value?: string
}

export const BlockedTimeInput = ({value}: Props) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  function handleTextChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    dispatch(setBlockedTimeReason(event.target.value))
  }

  return (
    <StyledHolder>
      <StyledInput
        rows={3}
        value={value}
        onChange={handleTextChange}
        id="appointment-public-note"
        className="form-control outline-none"
        placeholder={intl.formatMessage({id: "blocked.time.reason.note.placeholder"})}
      />
    </StyledHolder>
  )
}

const StyledHolder = styled(Container)`
  padding-left: 0;
  padding-right: 0;
  padding-top: 1rem;
`

const StyledInput = styled.textarea`
  outline: none;

  &::placeholder {
    font-style: italic;
    font-size: .8444444rem;
    color: var(--falcon-gray-500);
  }
`